import { NO, YES } from "uicore-ts"


// ============================================================================
// RHFeatureFlags
//
// Client-side visibility flags for features that are HIDDEN, not removed.
// The full implementation of a hidden feature stays in the codebase — only
// its UI entry points and badge counters are suppressed behind a flag here,
// so the feature can be restored by flipping a single value.
// ============================================================================

export class RHFeatureFlags {

    /**
     * Enables explicit acting-company affiliation retrieval and the multi-company
     * switcher.
     */
    static readonly multiCompanyAffiliationIsEnabled: boolean = YES

    /**
     * Controls the private offer-message thread feature ("Privaatsed sõnumid")
     * — the 1:1 procurer ↔ offerer messaging per offer part, which other
     * tenderers cannot see in the public "Teabevahetus" Q&A.
     *
     * While NO:
     *   - The "Privaatsed sõnumid" accordion in OfferResultView (offerer) and
     *     the "Privaatsed sõnumid" section in OfferDetailDialogView (procurer)
     *     are not added to the view tree.
     *   - RHNotificationStore suppresses all unread-offer-message counters at
     *     the source, so no nav/row/tab/accordion dot can light up for them.
     *   - No view code calls SendOfferMessage / RetrieveOfferMessages /
     *     MarkOfferMessagesAsRead — server endpoints stay untouched.
     *
     * Flip to YES to restore the messaging UI and its unread-message dots.
     */
    static readonly offerMessagingIsVisible = NO

    /**
     * Controls the "Privaatne" subtab in Teabevahetus (RHQAView) — 1:1
     * procurer ↔ offerer-company threads, separate from offerMessagingIsVisible
     * above (that one is per offer part; this one is per procurement).
     *
     * While NO, RHQAView never shows the "Avalik"/"Privaatne" subtab bar, so
     * the Q&A screen looks exactly as it did before private messaging existed
     * and no unread-dot fetch for it ever runs. Already-sent private threads
     * are unaffected server-side and reappear once this flips back to YES.
     */
    static readonly procurementPrivateMessagingIsVisible = YES

    /**
     * Controls the "Loo täpsustav hange" action in RHOffersEvaluationView —
     * the entry point that spins off a directed reconciliation child
     * procurement for a tied-price part instead of picking a winner directly.
     *
     * While NO, the button is never added to the view tree, so no new
     * reconciliation procurement can be started from the UI. Deliberately
     * does NOT touch the reactive UI for an already-existing reconciliation
     * (the locked-part banner, "Loobu täpsustamisest", "Ava täpsustav hange",
     * and the parent/child links on Teabevahetus and Üldandmed) — those
     * reflect real server-side state and must keep working for any part that
     * already has one, so a part already in reconciliation is never left
     * without a way to finish or abandon it.
     */
    static readonly reconciliationProcurementCreationIsVisible = YES

}
